import React, { useState, useEffect } from 'react';

import Upload from 'v3/components/Upload';
import Text from 'v3/components/Text';

function Attachment({ setData }) {
  const [files, setFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [uploadKey, setUploadKey] = useState(Date.now());

  const MAX_FILES = 5;

  useEffect(() => {
    setData(old => ({
      ...old,
      files: files,
    }));
  }, [files]);

  function onFilesChanged({ target }, hasError) {
    if (hasError) {
      setErrors({ file: 'Algum arquivo selecionado é maior que 1MB.' });
      return;
    }

    setErrors({});

    const selectedFiles = [...target.files].map(file => ({
      file: {
        blob: file,
        size: file.size,
        name: file.name,
        type: file.type,
        tempPath: URL.createObjectURL(file),
      },
    }));

    const merged = [...files, ...selectedFiles];

    if (merged.length > MAX_FILES) {
      setErrors({ file: `Você pode enviar no máximo ${MAX_FILES} arquivos.` });
      return;
    }

    const unique = merged.filter(
      (v, i, a) => a.findIndex(t => t.file.name === v.file.name) === i
    );

    setFiles(unique);
  }

  function removeFile(name) {
    const updated = files.filter(f => f.file.name !== name);
    setFiles(updated);

    if (updated.length === 0) {
      setUploadKey(Date.now());
    }
  }


  function renderPreview(file) {
    const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
    const isPDF = file.type === 'application/pdf';

    if (isImage) {
      return (
        <img
          src={file.tempPath}
          alt={file.name}
          style={{ width: '100%', height: 'auto', maxHeight: 70, objectFit: 'cover' }}
        />
      );
    }

    if (isPDF) {
      return (
        <iframe
          src={file.tempPath}
          title={file.name}
          style={{ width: '100%', height: 70, border: 'none' }}
        />
      );
    }

    return <span style={{ fontSize: 12 }}>{file.name}</span>;
  }

  return (
    <>
      <Text>Adicione até 5 anexos</Text>

      <Upload
        key={uploadKey}
        name="file"
        label="Arquivos até 1MB (JPG, PNG, PDF)"
        accept=".jpg,.jpeg,.png,.pdf"
        multiple
        onChange={onFilesChanged}
        error={errors.file}
        ignoreValidation
      />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 20 }}>
        {files.map(({ file }, index) => (
          <div
            key={index}
            style={{
              width: 100,
              height: 100,
              border: '1px solid #ccc',
              borderRadius: 8,
              padding: 4,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              flexDirection: 'column',
              backgroundColor: '#f9f9f9',
            }}
          >
            {renderPreview(file)}

            <button
              onClick={() => removeFile(file.name)}
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
                background: 'red',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: 20,
                height: 20,
                cursor: 'pointer',
                fontSize: 12,
                lineHeight: '20px',
                textAlign: 'center',
              }}
              title="Remover"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </>
  );
}

export default Attachment;
